import { RootState } from '..'

const organizationUsers = (state: RootState) => state.users?.organizationUsers
const teamMembers = (state: RootState) => state.reports?.openedCase?.teamMembers

export default {
  organizationUsers,
  teamMembers,
}
